import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import * as React from 'react';
import { mergeStyles } from '@cian/utils';
import * as styles from '../../styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
var UNDERGROUND_LINE_SHIFT = 4;
export var UndergroundLines = function UndergroundLines(_ref) {
  var lines = _ref.lines,
    isMobile = _ref.isMobile;
  if (!lines.length) {
    return null;
  }
  return /*#__PURE__*/_jsx("div", _objectSpread(_objectSpread({}, mergeStyles(styles['lines-container'], isMobile && styles['lines-container--mobile'])), {}, {
    children: lines.map(function (line, index) {
      var zIndex = lines.length;
      return /*#__PURE__*/_jsx("div", {
        className: styles['underground-line'],
        style: {
          backgroundColor: "#".concat(line.lineColor),
          left: UNDERGROUND_LINE_SHIFT * index,
          zIndex: zIndex - index
        }
      }, index);
    })
  }));
};